import LaboratoryClientModel from "./LaboratoryClientModel";
import ModusServiceModel from "../ModusServiceModel";
import LaboratoryModel from "./LaboratoryModel";
import CustomerModel from "../crm/CustomerModel";
import ResultModel from "./ResultModel";
import LaboratoryContactModel from "./LaboratoryContactModel";
import ResultEventSampleCollection from "@/collections/modus/ResultEventSampleCollection";
import ResultNutrientCollection from "@/collections/modus/ResultNutrientCollection";
import ResultNutrientRecommendationCollection from "@/collections/modus/ResultNutrientRecommendationCollection";
import ResultRecommendationCollection from "@/collections/modus/ResultRecommendationCollection";
import LaboratoryClientContactModel from "./LaboratoryClientContactModel";

export default class ResultEventModel extends ModusServiceModel {
  modelName() {
    return 'result-events';
  }
  defaults() {
    return {
      id: null,
      result_id: null,
      result: null,
      laboratory_id: null,
      laboratory: null,
      laboratory_client_id: null,
      laboratory_client: null,
      laboratory_contact_id: null,
      laboratory_contact: null,
      laboratory_client_contact_id: null,
      laboratory_client_contact: null,
      fmis_profile_id: null,
      fmis_profile: null,
      laboratory_event: null,
      event_code: null,
      sample_count: null,
      soil: null,
      water: null,
      tissue: null,
      tissue_crop: null,
      tissue_plant_part: null,
      nematode: null,
      residue: null,
      received_date: null,
      processed_date: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      depth_references: {},
      result_event_samples: {},
      result_nutrients: {},
      result_nutrient_recommendations: {},
      result_recommendations: {}
    }

  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      result_id: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      laboratory_client_id: (val) => (this.nullStringMutator(val)),
      laboratory_contact_id: (val) => (this.nullStringMutator(val)),
      laboratory_client_contact_id: (val) => (this.nullStringMutator(val)),
      fmis_profile_id: (val) => (this.nullStringMutator(val)),
      laboratory_event: (val) => (this.nullStringMutator(val)),
      event_code: (val) => (this.nullStringMutator(val)),
      sample_count: Number,
      soil: Boolean,
      water: Boolean,
      tissue: Boolean,
      tissue_crop: (val) => (this.nullStringMutator(val)),
      tissue_plant_part: (val) => (this.nullStringMutator(val)),
      nematode: Boolean,
      residue: Boolean,
      received_date: (val) => (this.nullStringMutator(val)),
      processed_date: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getResult() {
    return this.getRelatedModel(ResultModel, 'result');
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }
  getCustomer() {
    return this.getRelatedModel(CustomerModel, 'customer');
  }
  getLaboratoryClient() {
    return this.getRelatedModel(LaboratoryClientModel, 'laboratory_client');
  }
  getLaboratoryContact() {
    return this.getRelatedModel(LaboratoryContactModel, 'laboratory_contact');
  }
  getLaboratoryClientContact() {
    return this.getRelatedModel(LaboratoryClientContactModel, 'laboratory_client_contact');
  }
  getResultEventSamples() {
    const collection = new ResultEventSampleCollection();
    const filter = collection.getFilter();

    filter.sortAddAsc('number');

    return this.getRelatedCollection(collection, 'result_event_samples');
  }
  getResultNutrients() {
    return this.getRelatedCollection(new ResultNutrientCollection(), 'result_nutrients');
  }
  getResultNutrientRecommendations() {
    return this.getRelatedCollection(new ResultNutrientRecommendationCollection(), 'result_nutrient_recommendations');
  }
  getResultRecommendations() {
    return this.getRelatedCollection(new ResultRecommendationCollection(), 'result_recommendations');
  }
  formatType() {
    let type = null;

    if (this.get('soil')) {
      type = 'Soil';
    } else if (this.get('water')) {
      type = 'Water';
    } else if (this.get('tissue')) {
      type = 'Tissue';
    } else if (this.get('nematode')) {
      type = 'Nematode';
    } else if (this.get('residue')) {
      type = 'Residue';
    }
    
    return type;
  }
}
